import { render, staticRenderFns } from "./viewMore.vue?vue&type=template&id=7bd5752d&scoped=true"
import script from "./viewMore.vue?vue&type=script&lang=js"
export * from "./viewMore.vue?vue&type=script&lang=js"
import style0 from "./viewMore.vue?vue&type=style&index=0&id=7bd5752d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd5752d",
  null
  
)

export default component.exports